import React from "react";
import Layout from "layouts";
import CustomersComponent from "./CustomersComponent";

export default function Customers() {
  return (
    <Layout breadCrumb={[{ label: "Customers", to: "/customers" }]}>
      <CustomersComponent />
    </Layout>
  );
}
